module.exports = __webpack_public_path__ + "static/media/Allison Finley Headshot.51a59aa4.jpeg";